export default {
  title: '',
  homeMenu: {
    name: 'Reset Password',
    desc: 'Reset or modify my password'
  }
}
